import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingStep from '../components/OnboardingStep';
import { toast } from 'sonner';

const NameEntryNew = () => {
  const navigate = useNavigate();
  const [name, setName] = useState(localStorage.getItem('userName') || '');
  
  const handleContinue = () => {
    if (!name.trim()) {
      toast.error('Please enter your name');
      return;
    }
    
    localStorage.setItem('userName', name.trim());
    navigate('/date-of-birth');
  };
  
  return (
    <OnboardingStep
      step={1}
      totalSteps={5}
      title="Let's start with your name"
      reassurance="You can always edit this later"
      trustNote="Your data stays private and secure. We never share it."
      onContinue={handleContinue}
      continueDisabled={!name.trim()}
      showBack={false}
    >
      <div className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-stone-700 mb-2 block">
            Full Name
          </span>
          <input
            type="text"
            placeholder="Enter your full name"
            className="w-full px-4 py-4 rounded-input bg-stone-50 border-2 border-transparent focus:border-cosmic-500 focus:bg-white transition-all text-lg outline-none"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </label>
      </div>
    </OnboardingStep>
  );
};

export default NameEntryNew;